export default __webpack_public_path__ + "static/media/balancer.673147f6.svg";